










































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { PatientItem, DefaultPatientItem } from "@/components/ai/types";

@Component({})
/** お試し利用者詳細ビュアー */
export default class ExperimentPatientInfoViewer extends Vue {
  /** Prop */

  /** 利用画面 1:計画書 2:報告書 */
  @Prop({ default: 1 }) private viewType!: number;

  /** 利用者情報 */
  @Prop({
    default: () => {
      DefaultPatientItem;
    },
  })
  private patientItem!: PatientItem;

  /** 関数 */

  /** PDFプレビュー */
  private previewPdf(pdfPath: string) {
    window.open(pdfPath, "_blank");
  }
}
